import {
  JudgeReviewActionDistribution,
  JudgeReviewActionDocument,
  JudgeReviewDocumentStatus,
  JudgeReviewFiling,
} from '@data-contracts';

/**
 * Helpers for the per-document action model.
 *
 * A filing carries a roster (`judgeReviewDocuments`, each with a `status`) and at most one
 * in-progress action (`currentAction`). The action owns the documents the judge is acting
 * on together, their working copies (`judgeReviewDocumentStoreId`), their edits
 * (judicial action, option, annotations) and the distribution. Everything the studio,
 * recipients and confirm pages read or patch lives under `currentAction`.
 */

/** The documents of the in-progress action; empty when none is in progress. */
export function actionDocuments(
  filing: JudgeReviewFiling | null | undefined,
): JudgeReviewActionDocument[] {
  return filing?.currentAction?.documents ?? [];
}

/** The distribution of the in-progress action, when there is one. */
export function actionDistribution(
  filing: JudgeReviewFiling | null | undefined,
): JudgeReviewActionDistribution | undefined {
  return filing?.currentAction?.distribution;
}

/** Whether the roster document has already been submitted (read-only). */
export function isSubmittedStatus(
  status: JudgeReviewDocumentStatus | null | undefined,
): boolean {
  return status === JudgeReviewDocumentStatus.Submitted;
}

/** JSON Patch path prefixes for the in-progress action. */
export const ACTION_PATH = '/currentAction';
export const ACTION_DISTRIBUTION_PATH = `${ACTION_PATH}/distribution`;
export const actionDocumentPath = (index: number): string =>
  `${ACTION_PATH}/documents/${index}`;
